import React, { useState, useEffect } from 'react'
import './ViewerLayoutWrap.less'

const PDFWrap = ({
  iframeUrl
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const cancelLoading = () => {
    setIsLoading(false)
  }
  const [previewFile, setPreviewFile] = useState<any>()

  const showPdf = () => {
    var embedContainer = document.getElementById('embedContainer');
    if (embedContainer) {
      embedContainer.innerHTML = ''; // 清空当前内容
      var newEmbed = document.createElement('iframe');
      newEmbed.setAttribute('class', 'iframe-box');
      newEmbed.setAttribute('width', '100%');
      newEmbed.setAttribute('height', '100%');
      newEmbed.setAttribute('src', iframeUrl);
      embedContainer.appendChild(newEmbed);

      newEmbed.onerror  = function() {
        console.log("显示失败")
        // 如果 PDF 文件加载成功，隐藏错误信息
        var mes=document.getElementsByTagName("pre")[0];
        mes.style.color = '#fff';
      };

    }
  }

  useEffect(() => {
    showPdf()
  }, [])

  useEffect(() => {
    setIsLoading(true)
    console.log("iframeUrl===", iframeUrl)
    showPdf()
  }, [iframeUrl])

  return (
    <div className='viewer-main-page'>

      {
        // iframeUrl ? <embed className="iframe-box" src={iframeUrl} id="iframe1" width="100%" height="100%"></embed>
        iframeUrl ? <div id="embedContainer" style={{ width: '100%', height: '100%', color: '#fff' }}></div>
          : <p className='tips'>请先选中病人记录！</p>
      }
    </div>
  )
}

export default PDFWrap;
